import { Component, Input, Output, EventEmitter, OnInit, HostListener } from '@angular/core';
import {Router} from "@angular/router";
import * as moment from 'moment';
import { ServicesService } from "../../../../injections/services.service";

@Component({
  selector: 'services-list',
  templateUrl: '../../templates/partials/list-assign-services.html'
})
export class ListAssignServicesComponent implements OnInit{

    @Input() services;
    @Input() filter;
    @Output() sendToAppEmitter = new EventEmitter();
    @Output() clearSearchEmitter = new EventEmitter();
    @Output() modalCommentsEmitter = new EventEmitter();
    @Input() assignment;
    public page: number = 1;
    public showPager = true;
    constructor(private router:Router, private servicesService: ServicesService){}

    public goToDetail(id){
      this.router.navigate(['/services', id]);
    }

    public ToApp(type: string, service: object, $event: any){
      $event.stopPropagation();
      var data = {
        id: service["id_service"],
        idPro: service["id_professional"],
        type: type
      }
      this.manageSendToApp(data, service);
    }

    public showModal($event: any, service: object){
      $event.stopPropagation();
      this.modalCommentsEmitter.emit(service);
    }

    public manageSendToApp(event: any, service: object) {
      if(event["type"] == "send") this.sendToApp(event["id"], service);
      else if(event["type"] == "remove") this.removeFromApp(event["id"], service);
      else if(event["type"] == "sendWithPro") this.sendToAppWithPro(event["id"], event["idPro"], service);
      else if(event["type"] == "removeWithPro") this.removeFromAppWithPro(event["id"], service);
    }

    private sendToApp(id: string, service: object){
      this.servicesService.sendToApp(id).subscribe(result => {
          if(result == "OK") {
            service["app_queue"] = 1;
          }
      });
    }

    private removeFromApp(id: string, service: object){
      this.servicesService.removeFromApp(id).subscribe(result => {
        if(result == "OK") {
          service["app_queue"] = 0;
        }
      });
    }

    private removeFromAppWithPro(id: string, service: object){
      this.servicesService.removeFromAppProf(id).subscribe(result => {
        //console.log(result);
        if(result == "OK") {
          service["app_queue"] = 0;
          service["id_professional"] = null;
        }
      });
    }

    private sendToAppWithPro(id: string, idPro: string, service: object) {
      this.servicesService.sendToAppWithProf(id, idPro).subscribe(result => {
        if(result == "OK") {
          service["app_queue"] = 1;
        }
      });
    }

    ngOnChanges(changes: any) {}

    public addPage(){
        this.page++;
        if(this.services.length <= (this.page * 20)){
            this.showPager = false;
        }        
    }

    public setClass(service){
        if(service.canceled == 0 && (service.done == 1 || service.isBefore || (service.isSame && service.now >= service.time_end))){
          return 'c-slat--done';
        }else if(service.canceled == 1){
          return 'c-slat--canceled';
        }
        else if(service.now >= service.time_ini && service.now < service.time_end && service.isSame){
          return 'c-slat--course';
        }
    }

    ngOnInit() {}

}


// WEBPACK FOOTER //
// ./src/app/modules/assign/components/dummy/list-assign-services.component.ts